import {
  typeDownloadTransactionStatementsSuccess,
  typeGetGeneralContributionsSuccess,
  typeContributeFundsSuccess, 
  typeTransferToWalletSuccess,
  typeGetGeneralAmountSuccess,
  typeSetGeneralAmountSuccess,
  typeGetPersonalContributionSuccess,
  typeGetJointFundWalletSuccess,
} from '../../interfaces/joint-funds'

export const DOWNLOAD_TRANSACTION_STATEMENTS = 'DOWNLOAD_TRANSACTION_STATEMENTS'
export const DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS = 'DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS'
export const DOWNLOAD_TRANSACTION_STATEMENTS_FAILED = 'DOWNLOAD_TRANSACTION_STATEMENTS_FAILED'

export const GET_GENERAL_CONTRIBUTIONS = 'GET_GENERAL_CONTRIBUTIONS'
export const GET_GENERAL_CONTRIBUTIONS_SUCCESS = 'GET_GENERAL_CONTRIBUTIONS_SUCCESS'
export const GET_GENERAL_CONTRIBUTIONS_FAILED = 'GET_GENERAL_CONTRIBUTIONS_FAILED'

export const GET_PERSONAL_CONTRIBUTION = 'GET_PERSONAL_CONTRIBUTION'
export const GET_PERSONAL_CONTRIBUTION_SUCCESS = 'GET_PERSONAL_CONTRIBUTION_SUCCESS'
export const GET_PERSONAL_CONTRIBUTION_FAILED = 'GET_PERSONAL_CONTRIBUTION_FAILED'

export const CONTRIBUTE_FUNDS = 'CONTRIBUTE_FUNDS'
export const CONTRIBUTE_FUNDS_SUCCESS = 'CONTRIBUTE_FUNDS_SUCCESS'
export const CONTRIBUTE_FUNDS_FAILED = 'CONTRIBUTE_FUNDS_FAILED'

export const TRANSFER_TO_WALLET = 'TRANSFER_TO_WALLET'
export const TRANSFER_TO_WALLET_SUCCESS = 'TRANSFER_TO_WALLET_SUCCESS'
export const TRANSFER_TO_WALLET_FAILED = 'TRANSFER_TO_WALLET_FAILED'

export const SET_GENERAL_AMOUNT = 'SET_GENERAL_AMOUNT'
export const SET_GENERAL_AMOUNT_SUCCESS = 'SET_GENERAL_AMOUNT_SUCCESS'
export const SET_GENERAL_AMOUNT_FAILED = 'SET_GENERAL_AMOUNT_FAILED'

export const GET_GENERAL_AMOUNT = 'GET_GENERAL_AMOUNT'
export const GET_GENERAL_AMOUNT_SUCCESS = 'GET_GENERAL_AMOUNT_SUCCESS'
export const GET_GENERAL_AMOUNT_FAILED = 'GET_GENERAL_AMOUNT_FAILED'

export const GET_JOINT_FUND_WALLET = 'GET_JOINT_FUND_WALLET'
export const GET_JOINT_FUND_WALLET_SUCCESS = 'GET_JOINT_FUND_WALLET_SUCCESS'
export const GET_JOINT_FUND_WALLET_FAILED = 'GET_JOINT_FUND_WALLET_FAILED'


export interface DownloadTransactionStatements {
  type: typeof DOWNLOAD_TRANSACTION_STATEMENTS
}
export interface DownloadTransactionStatementsSuccess {
  type: typeof DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS
  payload: typeDownloadTransactionStatementsSuccess
}
export interface DownloadTransactionStatementsFailed {
  type: typeof DOWNLOAD_TRANSACTION_STATEMENTS_FAILED
  payload: any
}

export interface GetGeneralContributions {
  type: typeof GET_GENERAL_CONTRIBUTIONS
}
export interface GetGeneralContributionsSuccess {
  type: typeof GET_GENERAL_CONTRIBUTIONS_SUCCESS
  payload: typeGetGeneralContributionsSuccess
}
export interface GetGeneralContributionsFailed {
  type: typeof GET_GENERAL_CONTRIBUTIONS_FAILED
  payload: any
}

export interface GetPersonalContribution {
  type: typeof GET_PERSONAL_CONTRIBUTION
}
export interface GetPersonalContributionSuccess {
  type: typeof GET_PERSONAL_CONTRIBUTION_SUCCESS
  payload: typeGetPersonalContributionSuccess
}
export interface GetPersonalContributionFailed {
  type: typeof GET_PERSONAL_CONTRIBUTION_FAILED
  payload: any
}

export interface ContributeFunds {
  type: typeof CONTRIBUTE_FUNDS
}
export interface ContributeFundsSuccess {
  type: typeof CONTRIBUTE_FUNDS_SUCCESS
  payload: typeContributeFundsSuccess
}
export interface ContributeFundsFailed {
  type: typeof CONTRIBUTE_FUNDS_FAILED
  payload: any
}

export interface TransferToWallet {
  type: typeof TRANSFER_TO_WALLET
}
export interface TransferToWalletSuccess {
  type: typeof TRANSFER_TO_WALLET_SUCCESS
  payload: typeTransferToWalletSuccess
}
export interface TransferToWalletFailed {
  type: typeof TRANSFER_TO_WALLET_FAILED
  payload: any
}

export interface SetGeneralAmount {
  type: typeof SET_GENERAL_AMOUNT
}
export interface SetGeneralAmountSuccess {
  type: typeof SET_GENERAL_AMOUNT_SUCCESS
  payload: typeSetGeneralAmountSuccess
}
export interface SetGeneralAmountFailed {
  type: typeof SET_GENERAL_AMOUNT_FAILED
  payload: any
}

export interface GetGeneralAmount {
  type: typeof GET_GENERAL_AMOUNT
}
export interface GetGeneralAmountSuccess {
  type: typeof GET_GENERAL_AMOUNT_SUCCESS
  payload: typeGetGeneralAmountSuccess
}
export interface GetGeneralAmountFailed {
  type: typeof GET_GENERAL_AMOUNT_FAILED
  payload: any
}

export interface GetJointFundWallet {
  type: typeof GET_JOINT_FUND_WALLET
}
export interface GetJointFundWalletSuccess {
  type: typeof GET_JOINT_FUND_WALLET_SUCCESS
  payload: typeGetJointFundWalletSuccess
}
export interface GetJointFundWalletFailed {
  type: typeof GET_JOINT_FUND_WALLET_FAILED
  payload: any
}

export type JointFundsActionConstants =
  | DownloadTransactionStatements
  | DownloadTransactionStatementsSuccess
  | DownloadTransactionStatementsFailed
  | GetGeneralContributions
  | GetGeneralContributionsSuccess
  | GetGeneralContributionsFailed
  | GetPersonalContribution
  | GetPersonalContributionSuccess
  | GetPersonalContributionFailed
  | ContributeFunds
  | ContributeFundsSuccess
  | ContributeFundsFailed
  | SetGeneralAmount
  | SetGeneralAmountSuccess
  | SetGeneralAmountFailed
  | TransferToWallet
  | TransferToWalletSuccess
  | TransferToWalletFailed
  | GetGeneralAmount
  | GetGeneralAmountSuccess
  | GetGeneralAmountFailed
  | GetJointFundWallet
  | GetJointFundWalletSuccess
  | GetJointFundWalletFailed